import {TaskType} from '../../../tasks/enums/TaskType';
import {FILE_REQUIREMENT_COLLECTION} from '../../domain/config';
import {getUpdateTemplateFileRequirement} from '../../reducers/state';
import {makeEditFileReqModal} from '../config/configEditReqRequests';
import {UPDATE_TEMPLATE_FILE_PREFIX} from '../state';


export const {
  /** @type {ReduxRequestModal} */
  requestModal: updateTemplateFileRequirementRequestModal,
} = makeEditFileReqModal({
  isCreate: false,
  taskType: TaskType.TEMPLATE,
  prefix: UPDATE_TEMPLATE_FILE_PREFIX,
  getState: getUpdateTemplateFileRequirement,
  path: FILE_REQUIREMENT_COLLECTION,
});



// WEBPACK FOOTER //
// ./src/js/requirements/redux/files/updateTemplateFileRequirement.js